import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { detectEmbedMode, persistEmbedMode } from '../helpers/embedMode';

const useEmbedMode = (): boolean => {
  const [searchParams] = useSearchParams();
  const embedParam = searchParams.get('embed');

  const [isEmbed, setIsEmbed] = useState(() => detectEmbedMode());

  useEffect(() => {
    setIsEmbed(persistEmbedMode());
  }, [embedParam]);

  return useMemo(() => isEmbed, [isEmbed]);
};

export default useEmbedMode;
